import { arrayUnion, updateDoc, doc } from "firebase/firestore";
import { db } from "../Firebase/firebase";

// use a Set to check if the product is in the cart and change the button to say remove
const pushProductToCloud = async (e, quantity, userId, cart) => {
  e.stopPropagation()
  const pname = e.target.getAttribute("pname");
  const pprod = e.target.getAttribute("pprod");
  const ptaxes = e.target.getAttribute("ptaxes");
  const pid = e.target.getAttribute("pid");
  const isProductInCart = cart?.filter((item) => item.pId === pid)
  const docRef = doc(db, "users", userId);
  if (isProductInCart?.length) {
    // console.log(isProductInCart)
    return;
  } else {
    try {
      await updateDoc(docRef, {
        cart: arrayUnion({
          pId: pid,
          pName: pname,
          pPrice: pprod,
          pTaxes: ptaxes,
          pQuantity: quantity,
        }),
      });
      quantity = 1;
    } catch (err) {
      console.log(err, "Can't add product");
    }
  }
};

export default pushProductToCloud;
